var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INFO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.38 0-256 114.62-256 256s114.62 256 256 256 256-114.62 256-256-114.62-256-256-256z",
    fill: "#e03757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.11 399.43c153.89 0 278.65-124.76 278.65-278.65a278.3 278.3 0 0 0 -13.44-85.78 254.79 254.79 0 0 0 -129.32-35c-141.38 0-256 114.62-256 256a254.72 254.72 0 0 0 35.68 130.4 278.38 278.38 0 0 0 84.43 13.03z",
    fill: "#f04760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.89 429.65a41.61 41.61 0 1 1 41.61-41.65 41.61 41.61 0 0 1 -41.61 41.65zm40.33-143.3a28 28 0 0 1 -8.22 16.95 28.91 28.91 0 0 1 -17.26 8.07h-.19a108 108 0 0 1 -12.28.7 140.28 140.28 0 0 1 -14.73-.7h-.2a28.91 28.91 0 0 1 -17.25-8.07 28 28 0 0 1 -8.22-16.95c-1-9.39-1.5-74.6-1.5-89.13s.51-79.91 1.5-89.3a28 28 0 0 1 8.22-17 29 29 0 0 1 17.25-8.07h.2a106.83 106.83 0 0 1 14.73-.45 74.15 74.15 0 0 1 12.27.45h.2a29 29 0 0 1 17.26 8.15 28 28 0 0 1 8.22 17c1 9.39 1.5 74.78 1.5 89.3s-.51 79.7-1.5 89.05z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRedIcon);
export default __webpack_public_path__ + "static/media/warning_red_icon.565d48ffc1899ab1a6850ed7d85a54ed.svg";
export { ForwardRef as ReactComponent };